module.exports = __webpack_public_path__ + "media/images/admin/icons/globe-ad61f877bb84ebf2538cd388818a365c.svg";